"use client";

import { useEffect } from "react";
import { pixelTrack } from "./MetaPixelTracker";

/**
 * Fires a Meta Pixel event once when this component mounts.
 *
 * Used for funnel checkpoints — e.g. "QuoteStarted" when someone enters the
 * quote flow. These mid-funnel custom events give two things the Lead
 * conversion alone can't:
 *   1. A retargeting audience of people who started but didn't submit
 *      (QuoteStarted minus Lead = quote abandoners).
 *   2. A higher-volume signal so Meta's optimization learns faster.
 *
 * Drop into any (server or client) page; it renders nothing.
 */
export default function PixelEventTracker({
  event,
  params,
}: {
  event: string;
  params?: Record<string, unknown>;
}) {
  useEffect(() => {
    pixelTrack(event, params);
    // Fire exactly once per mount. params is intentionally excluded from
    // deps — a re-render with a fresh object identity must not re-fire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
